import { Table } from '@material-ui/core'
import { DadosTipologia } from 'models/Viabilidade/Tipologia'
import NumberFormat from 'react-number-format'
import { TableCellBoldCentralizado, TableCellCentralizado, TableContainerCustomizado, TableRowBranca, TableRowVerdeClaro } from '../../index.style'

const TabelaTipologias: React.FC<{ dados: DadosTipologia[] }> = ({ dados }) => {
  let index = 0
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableTipologias">
        <TableRowVerdeClaro>
          <TableCellBoldCentralizado>Descrição do Produto</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Quantidade de Unidades</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Quantidade de Permutas</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Área Lote (m²)</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Tipologia Casas</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Área Casa (m²)</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Perímetro de Muro por Lote (m)</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Área Serviço Ext. (m²)</TableCellBoldCentralizado>
          <TableCellBoldCentralizado>Preço Tabela (R$/Unid)</TableCellBoldCentralizado>
        </TableRowVerdeClaro>
        {dados.map((tipologia) => (
          <TableRowBranca key={`tipologia${index++}`}>
            <TableCellCentralizado data-cy={`campoTipologiaDescricao${index}`}>{tipologia.descricao}</TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaQuantidadeUnidades${index}`}>
              <NumberFormat value={tipologia.quantidadeUnidades} displayType="text" thousandSeparator="." decimalSeparator="," />
            </TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaQuantidadePermutas${index}`}>
              <NumberFormat
                value={tipologia.quantidadePermutas}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
              />
            </TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaAreaLote${index}`}>
              <NumberFormat
                value={tipologia.areaLote}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaTipologiaCasas${index}`}>{tipologia.tipologiaCasas}</TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaAreaCasa${index}`}>
              <NumberFormat
                value={tipologia.areaCasa}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaPerimetroMuroPorLote${index}`}>
              <NumberFormat
                value={tipologia.perimetroMuroPorLote}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaAreaServicoExterna${index}`}>
              <NumberFormat
                value={tipologia.areaServicoExterna}
                displayType="text"
                thousandSeparator="."
                decimalSeparator=","
                allowEmptyFormatting={true}
                defaultValue="-"
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </TableCellCentralizado>
            <TableCellCentralizado data-cy={`campoTipologiaPrecoTabela${index}`}>
              <NumberFormat value={tipologia.precoTabela} displayType="text" thousandSeparator="." decimalSeparator="," />
            </TableCellCentralizado>
          </TableRowBranca>
        ))}
      </Table>
    </TableContainerCustomizado>
  )
}

export default TabelaTipologias
